import { Table } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import Button from "../../../components/Button";
import Page from "../../../components/Page";
import NewLocation from "./NewLocation";
import Delete from "../../../assets/delete.svg";
import { backendUrl } from "../../../constants";
import "./styles.css";

const Index = ({ setRefetch }) => {
  let createdBy = JSON.parse(localStorage.getItem("userData"));
console.log("rece", createdBy)
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  //Delete Location
  const deleteLocation = (id) => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}empLocation/deleteEmpLocation/${id}`, options)
      .then((response) => response.json())
      .then((response) => {})

      .catch((err) => console.error(err));
  };
  const rows = tableData.map((element) => (
    <tr key={element.value}>
      <td>{element.name}</td>
      <td>{element.address}</td>
      <td>{element.city}</td>
      <td>{element.state}</td>
      <td>{element.zipCode}</td>
      <td>
        <img
          onClick={() => deleteLocation(element.value)}
          src={Delete}
          width="30px"
          className="delete"
        />
      </td>
    </tr>
  ));

  //Get Data 
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}empLocation/listEmpLocation/${createdBy.id}`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            value: obj._id,
            name: obj.locationName,
            address: obj.address,
            city: obj.city,
            state: obj.state,
            zipCode: obj.zipCode,
          };
          setTableData((emp) => [...emp, a]);
        });
      })

      .catch((err) => console.error(err));
  }, []);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="location-main">
        <h2 className="text-dark text-center">Company Locations</h2>
        <Button
          title="Add Location"
          primary={true}
          width="180px"
          style={{ marginLeft: "auto" }}
          onClick={() => setShowModal(true)}
        />
        <Table>
          <thead>
            <tr>
              <th>Location Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Zip Code</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
        <NewLocation
          opened={showModal}
          setOpened={setShowModal}
          setRefetch={setRefetch}
        />
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
